import * as React from "react";
import ImageView from "../../../../components/SmartImage";
import DiscountInfoCard from "./DiscountInfoCard";
import { BottomViews } from "../BottomViews";
import { PriceViews } from "../PriceViews";
import { NameViews } from "../NameViews";
import { ActTagViewForPc } from "../ActTagViews";
import { ProductCardWrap, DescriptionWrap, ProductCardPoster, } from "./styles";
import { LinkTargetType, ModuleLayoutStyle } from "../../../../services/playground";
import { transformAParam } from "../../../../utils/browser";
import { ShipTo24Hours as ShipTo24HoursBox } from "../ShipTo24Hours";
export class ProductCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { product, gridCol, posterRatio = 1, layoutStyle, placeholderBg = "", collectOptions = {}, smartImageProps = {} } = this.props;
        const { imgOnBottomLeft, imgOnTopLeft, imgOnTopRight, titleIcon, collect, actTags, shipIn24hours, flash } = product.extra || {};
        const aProps = transformAParam({
            isInApp: false,
            link: product.url,
            aTarget: LinkTargetType.Blank,
            onClick: this.props.onClick,
        });
        return (React.createElement(ProductCardWrap, Object.assign({}, aProps, { width: this.props.width }),
            React.createElement(ProductCardPoster, { posterRatio: posterRatio, layoutStyle: layoutStyle, style: {
                    background: `url(${placeholderBg}) center`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    width: this.props.width,
                } },
                React.createElement(DiscountInfoCard, { discountInfo: imgOnTopRight, tagInfo: imgOnTopLeft, themeTag: imgOnBottomLeft, flash: flash }),
                React.createElement(ImageView, Object.assign({ src: product === null || product === void 0 ? void 0 : product.img }, smartImageProps, { online: true, placeholder: placeholderBg, fallbackSrc: placeholderBg, imgClass: "productImage", fit: true }))),
            React.createElement(DescriptionWrap, { gridCol: gridCol },
                React.createElement(React.Fragment, null,
                    React.createElement(NameViews, { name: product.name, columnNum: actTags ? 1 : 2, titleTag: (titleIcon === null || titleIcon === void 0 ? void 0 : titleIcon.img) || "" }),
                    actTags && React.createElement(ActTagViewForPc, { actTags: actTags }),
                    React.createElement(PriceViews, { className: `priceView${ModuleLayoutStyle.Orange}`, price: product.price, originPrice: product.originPrice }),
                    collect && React.createElement(BottomViews, { columnNum: gridCol, collect: collect, collectOptions: collectOptions }),
                    shipIn24hours && React.createElement(ShipTo24HoursBox, { text: shipIn24hours })))));
    }
}
